import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'reduceString',
    standalone: false
})
export class ReduceStringPipe implements PipeTransform {

  transform(value: string, toReduce: string): string {
    value = value.toLowerCase().replace(toReduce.toLowerCase(), '');
    return value;
  }
}
